import React, { useState } from "react";

interface CreateSpecModalProps {
    onClose: () => void;
    onConfirm: (data: {
        name: string;
        vertical: "Insurance" | "Home Services" | "Legal" | "Debt" | "Travel" | "Other";
        product: string;
        type: string;
        description: string;
        visible: boolean;
        file: File | null;
    }) => void;
}

export default function CreateSpecModal({ onClose, onConfirm }: CreateSpecModalProps) {
    const [name, setName] = useState("");
    const [vertical, setVertical] = useState<"Insurance" | "Home Services" | "Legal" | "Debt" | "Travel" | "Other">("Insurance");
    const [product, setProduct] = useState("Leads");
    const [type, setType] = useState("Direct Post");
    const [description, setDescription] = useState("");
    const [visible, setVisible] = useState(true);
    const [file, setFile] = useState<File | null>(null);

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-96 shadow-lg max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                    Create Spec File
                </h2>

                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Name"
                    className="w-full mb-3 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                />

                <select
                    value={vertical}
                    onChange={(e) => setVertical(e.target.value as any)}
                    className="w-full mb-3 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                    <option>All</option>
                    <option>Insurance</option>
                    <option>Home Services</option>
                    <option>Legal</option>
                    <option>Debt</option>
                    <option>Travel</option>
                    <option>Other</option>
                </select>

                <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Description"
                    rows={3}
                    className="w-full mb-3 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white resize-none"
                />

                <select
                    value={product}
                    onChange={(e) => setProduct(e.target.value)}
                    className="w-full mb-3 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                    <option>Leads</option>
                    <option>Calls</option>
                    <option>Traffic</option>
                </select>

                <select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    className="w-full mb-3 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                    <option>Direct Post</option>
                    <option>Ping Post</option>
                    <option>RTB</option>
                    <option>Availability Ping</option>
                    <option>N/A</option>

                </select>

                <label className="flex items-center gap-2 mb-3 text-gray-900 dark:text-white">
                    <input
                        type="checkbox"
                        checked={visible}
                        onChange={(e) => setVisible(e.target.checked)}
                    />
                    Visible
                </label>

                <input
                    type="file"
                    accept=".html"
                    onChange={(e) => setFile(e.target.files?.[0] || null)}
                    className="w-full mb-4 text-gray-900 dark:text-white"
                />

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() =>
                            onConfirm({
                                name,
                                vertical,
                                product,
                                type,
                                description,
                                visible,
                                file,
                            })
                        }
                        className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
                    >
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
}